import { Link } from '../../cdl/Link/Link';
import { Text } from '../../cdl/Text/Text';
import { BudgetDonutChart } from '../../common/BudgetDonutChart/BudgetDonutChart';
import { formatMoney } from '../../common/helpers/formatMoney.helper';
import { translate } from '../../common/helpers/translate.helper';
import { useVesselBudgetDetails } from '../../common/hooks/useVesselBudgetDetails';
import { useVesselDetails } from '../../common/hooks/useVesselDetails';
import { Box } from '../../common/ui/Box';

import { OrderVesselTanks } from './OrderVesselTanks';

const LubricationChart = ({ downloadUrl }) => {
    return (
        <Link href={downloadUrl} external>
            {translate('order.lubricationChart')}
        </Link>
    );
};

const BudgetDetails = ({ vesselId }) => {
    const { budgetData, isPending, notFound } = useVesselBudgetDetails(vesselId);

    if (isPending || notFound) {
        return null;
    }

    return (
        <Box display="flex" alignItems="center">
            <BudgetDonutChart budget={budgetData.budget.amount} spentBudget={budgetData.spentBudget.amount} size={22} />

            <Text variant="body" marginLeft={4} marginRight={8}>
                {translate('budgets.budgetAvailable')}
            </Text>

            <Text
                variant="body"
                fontWeight={600}
                color={budgetData.remainingBudget.amount < 0 ? 'negative.foreground' : null}
            >
                {formatMoney({
                    value: budgetData.remainingBudget.amount,
                    currency: budgetData.remainingBudget.currency,
                })}
            </Text>
        </Box>
    );
};

export const OrderVesselInformation = ({ vesselId }) => {
    const vesselQuery = useVesselDetails(vesselId);

    if (!vesselId || vesselQuery.isPending) {
        return null;
    }

    return (
        <Box>
            <Box display="flex" gap={24}>
                {vesselQuery.data.lubricationChart ? (
                    <LubricationChart downloadUrl={vesselQuery.data.lubricationChart.downloadUrl} />
                ) : null}
                <BudgetDetails vesselId={vesselQuery.data.id} />
            </Box>

            <OrderVesselTanks vesselId={vesselQuery.data.id} />
        </Box>
    );
};
